import React from 'react'
import {VerticalEllipsisIcon} from '@modifi/ui'
import {airBlue} from '@modifi/colors'

import {ActionsIconWrapper} from './styles'

type ActionsDropdownHeaderProps = {
  isOpen?: boolean
}

const ActionsDropdownHeader: React.FC<ActionsDropdownHeaderProps> = ({
  isOpen = false,
  ...props
}) => (
  <ActionsIconWrapper isOpen={isOpen || false} {...props}>
    <VerticalEllipsisIcon color={airBlue} cursor="pointer" />
  </ActionsIconWrapper>
)

export default ActionsDropdownHeader
